import styled from 'styled-components';
import StarIcon from '@mui/icons-material/Star';

import { NgTooltip } from '../..';

const StyledWrapper = styled.span`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  color: #fbc02d;
  flex-shrink: 0;
`;

export const DefaultThemeBadge = () => (
  <NgTooltip title="Default theme" placement="top">
    <StyledWrapper>
      <StarIcon fontSize="small" />
    </StyledWrapper>
  </NgTooltip>
);
